exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh1[data-v-55138b9e] {\n  color: #cd0930!important;\n}\n.is-warning[data-v-55138b9e] {\n  color:#fff;\n  background-color: #fb922c;\n}\n.is-warning-middle[data-v-55138b9e] {\n  background-color: #faddc1;\n}\n.router-link-active[data-v-55138b9e] {\n  background: none!important;\n}\n\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/pages/errors/404.vue"],"names":[],"mappings":";AACA;EACE,yBAAyB;CAC1B;AACD;EACE,WAAW;EACX,0BAA0B;CAC3B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,2BAA2B;CAC5B","file":"404.vue","sourcesContent":["\nh1[data-v-55138b9e] {\n  color: #cd0930!important;\n}\n.is-warning[data-v-55138b9e] {\n  color:#fff;\n  background-color: #fb922c;\n}\n.is-warning-middle[data-v-55138b9e] {\n  background-color: #faddc1;\n}\n.router-link-active[data-v-55138b9e] {\n  background: none!important;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55138b9e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/errors/404.vue
// module id = 9mEs
// module chunks = 4